module.exports = __webpack_public_path__ + "a768e7de/img/at-icon.5d6fc5d8.svg";